import { createMuiTheme, makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  BoxDialog: {
    background: '#212121',
    color: '#fff',
    textAlign: 'center', 
    fontSize: 18
  },
  Button: {
    width: '120px', 
    height: '40px', 
    textTransform: 'uppercase',
    borderRadius: 5,
    background: '#373737',
    marginLeft: 20,

    '&:hover': { 
      border: '1px solid #fff',
    }
  },
  Title: {
    textAlign: 'center', 
    fontSize: 18, 
    flex: 1
  },
  Subtitle: { 
    fontSize: 14,
    color: '#fff',
    marginBottom: '30px'
  },
  ItemHeader: {
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center',
    width : '100%',
    flexDirection: 'column'
  },
  smallMargin: {
    marginTop: 15
  },
  textFieldSelect: {
    width: '100%', 
    marginBottom: 20
  },
  fullWidth: {
    width: '100%'
  }
}));

export const materialTheme = createMuiTheme({
  overrides: {
    MuiOutlinedInput: {
      root: {
        '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
            borderColor: '#fff',
        },
      },
      notchedOutline: {
        borderColor: '#fff'
      },
      input: {
        color: '#fff'           
      }  
    },
    MuiInputLabel: {
      outlined: {
        color: '#fff',
      }
    },
    MuiFormHelperText: {
      contained: {
        color: '#fff',
      }
    },
    MuiButton: {
      label: {
        color: '#fff'           
      }
    },
  },
});